import { inject, Injectable, signal } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';

import { RequestService } from './request.service';
import { Entity } from './entity.service';

import { getCurrUser } from '@proman/store/curr-user';
import { CONFIG } from '../config';

import { CurrUser } from '@proman/interfaces/object-interfaces';

import { AiFriendConversationComponent } from '@proman/ai/ai-friend-conversation.component';

@Injectable({
  providedIn: 'root'
})
export class AiFriendService {
  BottomSheet = inject(MatBottomSheet);
  Entity = inject(Entity);
  Request = inject(RequestService);
  store = inject(Store)

  selectedConversation = signal(0);
  afterClosed$ = new Subject<void>

  authorId: number;
  currUser: CurrUser;

  constructor(
  ) {
    this.store.select(getCurrUser).subscribe(res => this.currUser = res);
  }

  askFriend = (question: string, conversationId?: number) => {
    const body = { question };
    if (conversationId > 0) body['id'] = conversationId;
    return this.Request.post(`${CONFIG.api}smarton_prompt/ask_friend`, body)
  }

  openConversationSheet(id: number) {
    const callback = () => {
      this.BottomSheet.open(AiFriendConversationComponent, { /*hasBackdrop: false*/ }).afterDismissed().subscribe(() => {
        this.afterClosed$.next();
      });
    }

    if (id > 0) this.selectedConversation.set(id);
    callback();
  }

  checkPerson = () => this.authorId === this.currUser.person.id;
}
